import * as React from 'react';

import styles from './styles.module.scss';

interface OwnProps {
	onClose: () => void;
	/** What it will say in the filter token once applied. There is ONLY applied state */
	label: string;
}

type Props = OwnProps;

const SingleOptionFilter: React.FC<Props> = (props) => {
	const { label } = props;

	return (
		<div
			className={styles.additionalFilterWithoutDropdown}
			id={`accqa__additional-filter-single-option__${label}`}
		>
			<div className={styles.appliedFilter}>
				<div className={styles.appliedFilterContent}>
					{label}
				</div>
				<span className={`icon-close ${styles.icon}`} onClick={props.onClose} />
			</div>
		</div>
	);
};

export default React.memo(SingleOptionFilter);
